// extracted by css-extract-rspack-plugin
export default {"root":"bZ5Z3E","margins-both":"bfzmSq","marginsBoth":"bfzmSq","margins-top":"zPnOv9","marginsTop":"zPnOv9","margins-bottom":"f87qvO","marginsBottom":"f87qvO"};